<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-title>Pelunasan Tagihan External</v-card-title>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="No Tagihan"
                  dense
                  hide-details
                  v-model="formData.no_tagihan"
                  @keydown.enter="searchTagihan"
                  autofocus
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Tgl Lunas"
                  dense
                  hide-details
                  type="date"
                  v-model="formData.tgl_lunas"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content">
                <v-text-field label="Keterangan Pelunasan" dense hide-details v-model="formData.keterangan_pelunasan"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="lunaskan"
                  small
                >
                  Lunaskan
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-data-table
        :headers="dataHeaders"
        :items="data"
        :loading="loading.fetchData"
        :items-per-page="10"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.nilai_tagihan="{ item }">
          {{ formatCurrency(item.nilai_tagihan) }}
        </template>
        <template v-slot:item.lunas="{ item }">
          <v-chip :color="item.lunas === 'Y' ? 'success' : 'warning'" small>
            {{ item.lunas === 'Y' ? 'Lunas' : 'Belum' }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            x-small
            color="success"
            v-if="item.lunas === 'N'"
            @click="selectItem(item)"
          >
            Lunaskan
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PelunasanTagihanExternal",
  data() {
    return {
      loading: {
        saveData: false,
        fetchData: false
      },
      formData: {
        no_tagihan: "",
        tgl_lunas: "",
        id: null,
        keterangan_pelunasan: ""
      },
      dataHeaders: [
        { text: "POS", value: "pos" },
        { text: "Nama Penagih", value: "nama_penagih" },
        { text: "No Rekening", value: "no_rekening" },
        { text: "No Tagihan", value: "no_tagihan" },
        { text: "Keterangan", value: "keterangan_tagihan" },
        { text: "Nilai", value: "nilai_tagihan" },
        { text: "Jatuh Tempo", value: "tgl_jatuh_tempo" },
        { text: "Tgl Lunas", value: "tgl_lunas" },
        { text: "Keterangan Pelunasan", value: "keterangan_pelunasan" },
        { text: "Status", value: "lunas" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      data: []
    };
  },
  methods: {
    formatCurrency(val) {
      if (!val) return "0";
      return Number(val).toLocaleString("id-ID");
    },
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`tagihan-external`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response.data.message);
        });
    },
    async searchTagihan() {
      this.loading.fetchData = true;

      await axios
        .get(`tagihan-external?no_tagihan=${this.formData.no_tagihan}`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response.data.message);
        });
    },
    selectItem(item) {
      this.formData.id = item.id;
      this.formData.no_tagihan = item.no_tagihan;
    },
    async lunaskan() {
      if (!this.formData.id || !this.formData.tgl_lunas) {
        alert("Pilih tagihan dan isi tgl lunas");
        return;
      }

      this.loading.saveData = true;

      await axios
        .put(`tagihan-external/pelunasan/${this.formData.id}`, {
          tgl_lunas: this.formData.tgl_lunas,
          keterangan_pelunasan: this.formData.keterangan_pelunasan
        })
        .then(res => {
          this.loading.saveData = false;
          this.fetchData();
          this.formData.id = null;
          this.formData.no_tagihan = "";
          this.formData.tgl_lunas = "";
          this.formData.keterangan_pelunasan = "";
        })
        .catch(err => {
          this.loading.saveData = false;
          alert(err.response.data.message);
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}
</style>
